import {
    REPORT_TYPE_ADD_START,
    REPORT_TYPE_ADD_SUCCESS,
    REPORT_TYPE_ADD_ERROR,
    DELETE_REPORT_TYPE_START,
    DELETE_REPORT_TYPE_SUCCESS,
    DELETE_REPORT_TYPE_ERROR,
} from '../../constants';
import showToaster from '../../helpers/toasterMessages/showToaster';
import history from '../../core/history';

import { deleteReportType, updateReportTypeMutation } from '../../lib/graphql/admin/manageReportType';

export function updateReportTypeAction(values) {
    return async (dispatch, getState, { client }) => {

        await dispatch({ type: REPORT_TYPE_ADD_START });

        try {
            const dynamicReportType = values?.dynamicReportType?.length > 0 ? JSON.stringify(values.dynamicReportType) : JSON.stringify([]);
            const { data } = await client.mutate({
                mutation: updateReportTypeMutation,
                variables: {
                    id: Number(values?.id),
                    dynamicReportTypeData: dynamicReportType
                }
            });

            if (data?.updateReportType?.status === 200) {
                await dispatch({
                    type: REPORT_TYPE_ADD_SUCCESS,
                });
                history.push('/siteadmin/report-type');
                values?.id ? await showToaster({ messageId: 'reportTypeUpdateSuccess', toasterType: 'success' }) :
                    await showToaster({ messageId: 'reportTypeAddSuccess', toasterType: 'success' })
            } else {
                showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data?.updateReportType?.errorMessage })
                await dispatch({
                    type: REPORT_TYPE_ADD_ERROR,
                    payload: {
                        error: data?.updateReportType?.errorMessage
                    }
                });
            }
        } catch (error) {
            await dispatch({
                type: REPORT_TYPE_ADD_ERROR,
                payload: {
                    error
                }
            });
        }
    }
}

export function deleteReportTypeData(id) {
    return async (dispatch, getState, { client }) => {
        dispatch({ type: DELETE_REPORT_TYPE_START });
        try {
            const { data } = await client.mutate({
                mutation: deleteReportType,
                variables: { id },
            });
            if (data && data.deleteReportType && data.deleteReportType.status == 200) {
                dispatch({
                    type: DELETE_REPORT_TYPE_SUCCESS
                });
                showToaster({ messageId: 'reportTypeDeleteSuccess', toasterType: 'success' });
                return true;
            } else if (data && data.deleteReportType && data.deleteReportType.errorMessage == 'reportTypeDeleteError') {
                dispatch({
                    type: DELETE_REPORT_TYPE_ERROR
                });
                showToaster({ messageId: 'reportTypeDeleteError', toasterType: 'error' })
            } else {
                dispatch({
                    type: DELETE_REPORT_TYPE_ERROR
                });
                showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data?.deleteReportType?.errorMessage })
            }

        } catch (error) {
            dispatch({
                type: DELETE_REPORT_TYPE_ERROR
            });
            showToaster({ messageId: 'updateFailed', toasterType: 'error' })
        }
    }
}